var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.125C10.5523 2.125 11 2.57272 11 3.125V11.875C11 12.4273 10.5523 12.875 10 12.875C9.44772 12.875 9 12.4273 9 11.875V3.125C9 2.57272 9.44772 2.125 10 2.125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 10.875C3.67728 10.875 4.125 11.3227 4.125 11.875V15.875H15.875V11.875C15.875 11.3227 16.3227 10.875 16.875 10.875C17.4273 10.875 17.875 11.3227 17.875 11.875V16.25C17.875 16.681 17.7038 17.0943 17.399 17.399C17.0943 17.7038 16.681 17.875 16.25 17.875H3.75C3.31902 17.875 2.9057 17.7038 2.60095 17.399C2.2962 17.0943 2.125 16.681 2.125 16.25V11.875C2.125 11.3227 2.57272 10.875 3.125 10.875Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16789 8.04289C6.55842 7.65237 7.19158 7.65237 7.58211 8.04289L10 10.4608L12.4179 8.04289C12.8084 7.65237 13.4416 7.65237 13.8321 8.04289C14.2226 8.43342 14.2226 9.06658 13.8321 9.45711L10.7071 12.5821C10.3166 12.9726 9.68342 12.9726 9.29289 12.5821L6.16789 9.45711C5.77737 9.06658 5.77737 8.43342 6.16789 8.04289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1fdb174ce90e77e01b7fc6227570d33f.svg";
export { ForwardRef as ReactComponent };